<template>
   <nav class="navbar">
      <div class="container">
        <div>
          <a class="logo nav-btn" href="#home">
            <svg width="100%" height="100%" viewBox="0 0 1386 248" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g id="genevaWEB"><g id="geneva"><text x="55.657px" y="195.729px" style="font-family:'Corbel-Bold', 'Corbel', sans-serif;font-weight:700;font-size:216px;fill:#fff;">G<tspan x="188.575px 298.923px 443.76px 554.108px 667.936px " y="195.729px 195.729px 195.729px 195.729px 195.729px ">ENEVA</tspan></text></g><path d="M1355.22,0.001c15.578,0.148 29.881,13.518 30.033,30.033c0.216,62.477 0.216,124.955 0,187.432c-0.143,15.577 -13.481,29.876 -30.033,30.033c-441.725,1.4 -883.457,1.399 -1325.18,0c-15.551,-0.148 -29.876,-13.518 -30.033,-30.033c-0.199,-62.477 -0.199,-124.955 0,-187.432c0.147,-15.501 13.482,-29.876 30.033,-30.033c441.725,-1.401 883.457,-1.402 1325.18,0Zm-488.591,9.399c-278.794,0.178 -557.594,1.85 -836.387,1.85c-9.901,0.031 -18.89,8.593 -18.988,18.856c-0.198,62.47 -0.593,124.944 0.002,187.411c0.154,9.77 8.627,18.571 18.731,18.731c278.867,2.654 557.757,3.631 836.642,2.934l0,-229.782Zm201.744,186.386l36.72,-144.072l-33.696,0l-20.952,104.328l-25.488,-100.44l-29.592,0l-25.272,100.44l-31.659,-156.035l-34.992,0l46.563,195.779l34.344,0l25.056,-94.176l24.624,94.176l34.344,0Zm139.104,-115.56l0,-28.512l-98.496,0l0,144.072l103.248,0l0,-28.728l-70.632,0l0,-31.104l51.192,0l0,-27.648l-51.192,0l0,-28.08l65.88,0Zm68.472,115.56c8.641,0 16.452,-0.756 23.436,-2.268c6.984,-1.512 12.888,-3.924 17.712,-7.236c4.824,-3.312 8.568,-7.56 11.232,-12.744c2.664,-5.184 3.996,-11.52 3.996,-19.008c0,-5.76 -1.044,-10.764 -3.132,-15.012c-2.088,-4.248 -4.644,-7.776 -7.668,-10.584c-3.024,-2.808 -6.228,-4.968 -9.612,-6.48c-3.384,-1.512 -6.372,-2.556 -8.964,-3.132c1.728,-0.432 3.852,-1.368 6.372,-2.808c2.52,-1.44 4.896,-3.42 7.128,-5.94c2.232,-2.52 4.176,-5.544 5.832,-9.072c1.656,-3.528 2.484,-7.596 2.484,-12.204c0,-4.896 -0.864,-9.612 -2.592,-14.148c-1.728,-4.536 -4.536,-8.532 -8.424,-11.988c-3.888,-3.456 -8.928,-6.228 -15.12,-8.316c-6.192,-2.088 -13.752,-3.132 -22.68,-3.132l-54,0l0,144.072l54,0Zm-1.08,-62.64c2.449,0 5.112,0.252 7.992,0.756c2.88,0.504 5.544,1.44 7.992,2.808c2.448,1.368 4.464,3.276 6.048,5.724c1.584,2.448 2.376,5.616 2.376,9.504c0,4.32 -0.828,7.704 -2.484,10.152c-1.656,2.448 -3.708,4.32 -6.156,5.616c-2.448,1.296 -5.112,2.124 -7.992,2.484c-2.88,0.36 -5.472,0.54 -7.776,0.54l-21.168,0l0,-37.584l21.168,0Zm-1.944,-56.16c2.305,0 4.645,0.252 7.02,0.756c2.376,0.504 4.5,1.368 6.372,2.592c1.872,1.224 3.384,2.88 4.536,4.968c1.152,2.088 1.728,4.716 1.728,7.884c0,3.024 -0.576,5.58 -1.728,7.668c-1.152,2.088 -2.628,3.744 -4.428,4.968c-1.8,1.224 -3.888,2.124 -6.264,2.7c-2.376,0.576 -4.788,0.864 -7.236,0.864l-19.224,0l0,-32.4l19.224,0Z" style="fill:#3b9adb;"/></g></svg>
          </a>
        </div>
        <div class="navigation">
          <a href="#about" class="nav-btn">About</a>
          <a href="#services" class="nav-btn">Services</a>
          <a href="#partners" class="nav-btn">Partenaires</a>
          <a href="#contact" class="nav-btn">Contact</a>
          <div id="burgerBtn"></div>
        </div>
      </div>
      <div class="burger-menu">
        <a href="#about" class="nav-btn">About</a>
        <a href="#services" class="nav-btn">Services</a>
        <a href="#partners" class="nav-btn">Partenaires</a>
        <a href="#contact" class="nav-btn">Contact</a>
      </div>
    </nav>
</template>

<script>
import {initBurger} from '@/plugins/burger.js'
export default {
    mounted () {
        let goTop = document.querySelector('#go-to-top-btn')
        let html = document.querySelector('html')
        window.addEventListener('scroll',function(){
            let htmlTop = html.scrollTop
            let nav = document.querySelector('nav')            

            if(htmlTop >= 150){
                nav.classList.add('smaller')
            } else {
                nav.classList.remove('smaller')
            }
            
            if(htmlTop >= 450){
                goTop.classList.remove('hidden')
            } else {
                goTop.classList.add('hidden')
            }
        });
        document.querySelectorAll('.nav-btn').forEach(link => {
            link.addEventListener('click', function(e){
                let pos = document.querySelector(link.hash).offsetTop
                e.preventDefault()
                let currentPos = document.querySelector('html').scrollTop
                window.scrollBy({ 
                    top: pos-currentPos, // could be negative value
                    left: 0, 
                    behavior: 'smooth' 
                });
            })
        });
        initBurger();
    },
    methods: {
    },
}
</script>

<style lang="scss">
.navbar{
    position: fixed;
    width: 100%;
    padding: 34px 32px;
    z-index: 100;
    transition: .2s;
    .container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
    }
    & > div{
        height: 38px;
        .logo, .logo svg{
            display: block;
            height: 38px;
            width: auto;
            path{
                fill: white !important;
            }
        }
        .navigation{
                display: flex;
                align-items: center;
            a, a:focus, a:visited{
                color: white;
                font-size: 1rem;
                text-transform: uppercase;
                margin-left: 30px;
                display: block;
                font-family: $link-font;
                letter-spacing: .5px;
            }
        }
    
    }
    &.smaller{
        padding: 8px 32px;
        background-color: $main-color;
        box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.1);
        @include mq1024{
            padding: 8px 15px;
        }
    }
    @include mq1024{
        background-color: $main-color;
        padding: 8px 15px;
    }
    .burger-menu{
        position: absolute;
        top: 100%;
        right: -300px;
        height: 100vh;
        background-color: $main-color;
        transition: .3s;
        display: none;
        padding: 45px 0;
        a{
            color: white;
            display: block;
            padding: 15px 30px;
            min-width: 250px;
        }
        &.is-active{
            right: 0;
        }
        @include mq1024(){
            display: block;
        }
    }
}
#burgerBtn{
    display: none !important;
    @include mq1024{
        display: block !important;
    }
    
}

.navigation a{
    display: block;
    @include mq1024{
        display: none !important;
    }
}
</style>